/**
 * Shared background/text colour pairs for medical-necessity verdicts.
 *
 * Centralises the met / not-met / undetermined palette reused across the NCCN
 * review surfaces (summary list, evidence sections, verdict badges, and the
 * regimen-bar pill) so the colours are defined in exactly one place.
 * @module verdictColors
 */

/** A background/text colour pair for a verdict tag. */
export interface VerdictColor {
  /** Tag/pill background colour. */
  background: string;
  /** Tag/pill text colour. */
  text: string;
}

/** The verdict tones that share a colour treatment. */
export type VerdictTone = "met" | "notMet" | "undetermined";

/** Background/text colours keyed by verdict tone. */
export const VERDICT_COLORS: Record<VerdictTone, VerdictColor> = {
  met: { background: "#E6F3F0", text: "#005D49" },
  notMet: { background: "#FFE8E8", text: "#CC0300" },
  undetermined: { background: "#FFF3E0", text: "#C24400" },
};
